import type { App } from "../app.js";
import { memberName } from "../app.js";
import { formatDate, h, notice, plural, replace } from "../dom.js";
import { instagramChip, integrityChip, uploadChip } from "./status.js";

/** « Bibliothèque »: every deposit of both members, newest first, with its cover. */
export function libraryView(app: App): HTMLElement {
  const root = h("div", null, h("p", { class: "muted" }, "Chargement…"));
  void (async () => {
    try {
      const backend = app.connection.backend;
      const deposits = await backend.listDeposits();
      const covers = await backend.firstSlides(deposits.map((d) => d.id));
      const urls = new Map(
        await Promise.all(
          [...covers].map(async ([id, file]) => [id, await backend.objectUrl(file.storage_path).catch(() => "")] as const),
        ),
      );
      replace(
        root,
        h(
          "div",
          { class: "library-head" },
          h("div", null, h("h1", null, "Bibliothèque"), h("p", { class: "lede", style: "margin:0" }, deposits.length ? `${plural(deposits.length, "carrousel", "carrousels")}, partagés entre les membres.` : "Les carrousels déposés apparaissent ici.")),
          h("a", { class: "btn primary", href: "#/ajouter" }, "Ajouter un carrousel"),
        ),
        deposits.length
          ? h(
              "div",
              { class: "covers" },
              deposits.map((d) =>
                h(
                  "a",
                  { class: "card", href: `#/depot/${d.id}`, "aria-label": `Dépôt n°${d.number}, ${plural(d.slide_count, "slide", "slides")}` },
                  h(
                    "div",
                    { class: "cover" },
                    urls.get(d.id) ? h("img", { src: urls.get(d.id)!, alt: "", loading: "lazy" }) : null,
                    h("span", { class: "num" }, `n°${d.number}`),
                    h("span", { class: "count" }, plural(d.slide_count, "slide", "slides")),
                  ),
                  h(
                    "div",
                    { class: "body" },
                    h("div", { class: "chips" }, uploadChip(d), integrityChip(d), instagramChip(d)),
                    h("div", { class: "muted", style: "font-size:13px" }, `${formatDate(d.created_at)} · ${memberName(app, d.created_by)}`),
                  ),
                ),
              ),
            )
          : h("div", { class: "empty" }, h("h2", null, "Aucun carrousel pour l'instant"), h("p", { class: "muted" }, "Commencez par déposer un ZIP ou des images."), h("a", { class: "btn primary big", href: "#/ajouter" }, "Ajouter un carrousel")),
      );
    } catch (error) {
      replace(root, notice("bad", "Bibliothèque indisponible", error instanceof Error ? error.message : String(error), h("button", { class: "btn", onclick: () => app.refresh() }, "Réessayer")));
    }
  })();
  return root;
}
